module.exports = __webpack_public_path__ + "770cfc73f66eb0878ae432e9618527f9.png";